<template>
  <div class="commerceConnector">
    <div v-if="isHomeScreen" class="hairoil-home-container">
      <img :src="sectionimageData" class="section-bg" alt="" />
      <div class="hairoil-home-section">
        <div class="home-subtitle"></div>
        <h2 class="home-title">
          <img :src="headerimageData" alt="" />
        </h2>
        <p>{{ subtitleData }}</p>
        <a href="#" class="start-button" @click="showQuiz()">{{ ctalabelData }}</a>
      </div>
      <ul class="display-products">
        <li v-for="(primage, index) in prodoductimagesData" :key="index">
          <img :src="primage" alt="" />
        </li>
      </ul>
    </div>
    <div v-if="isQuizScreen" class="hairoil-question-container">
      <ul class="hairoil-question-section">
        <template v-for="(question, index) in questions.stepList" :key="question.Step.StepName">
          <li
            v-if="question.Step.StepName === questionId"
            class="hairoil-question-content"
            :data-question-id="question.Step.StepName"
          >
            <span class="question-number">Q{{ questionCount + 1 }}</span>
            <p>{{ question.Step.QuestionText }}</p>
            <div
              class="animated"
              :class="[question.Step.StepName === questionId ? 'slideInRight' : 'fadeOutLeft']"
            >
              <ul v-if="dataDisplayimagechoices === 'True'" class="lip-counsel-answers">
                <template v-for="answer in answers.optionList">
                  <li
                    v-if="question.Step.Option1 === answer.Option.OptionName"
                    :key="answer.Option.OptionName"
                    class="ripple-out"
                    @click="
                      result(answer.Option, question.Step.StepName);
                      getTaggingInfo(
                        pagecategoryData,
                        question.Step.QuestionText,
                        answer.Option.OptionText
                      );
                    "
                  >
                    <img :src="answer.Option.OptionImage" alt="" />
                  </li>
                  <li
                    v-if="question.Step.Option2 === answer.Option.OptionName"
                    :key="answer.Option.OptionName"
                    class="ripple-out"
                    @click="
                      result(answer.Option, question.Step.StepName);
                      getTaggingInfo(
                        pagecategoryData,
                        question.Step.QuestionText,
                        answer.Option.OptionText
                      );
                    "
                  >
                    <img :src="answer.Option.OptionImage" alt="" />
                  </li>
                  <li
                    v-if="question.Step.Option3 === answer.Option.OptionName"
                    :key="answer.Option.OptionName"
                    class="ripple-out"
                    @click="
                      result(answer.Option, question.Step.StepName);
                      getTaggingInfo(
                        pagecategoryData,
                        question.Step.QuestionText,
                        answer.Option.OptionText
                      );
                    "
                  >
                    <img :src="answer.Option.OptionImage" alt="" />
                  </li>
                  <li
                    v-if="question.Step.Option4 === answer.Option.OptionName"
                    :key="answer.Option.OptionName"
                    class="ripple-out"
                    @click="
                      result(answer.Option, question.Step.StepName);
                      getTaggingInfo(
                        pagecategoryData,
                        question.Step.QuestionText,
                        answer.Option.OptionText
                      );
                    "
                  >
                    <img :src="answer.Option.OptionImage" alt="" />
                  </li>
                  <li
                    v-if="question.Step.Option5 === answer.Option.OptionName"
                    :key="answer.Option.OptionName"
                    class="ripple-out"
                    @click="
                      result(answer.Option, question.Step.StepName);
                      getTaggingInfo(
                        pagecategoryData,
                        question.Step.QuestionText,
                        answer.Option.OptionText
                      );
                    "
                  >
                    <img :src="answer.Option.OptionImage" alt="" />
                  </li>
                </template>
              </ul>
              <template v-for="answer in answers.optionList" v-else>
                <span
                  v-if="question.Step.Option1 === answer.Option.OptionName"
                  :key="answer.Option.OptionName"
                  class="yes ripple-out"
                  @click="
                    result(answer.Option, question.Step.StepName);
                    getTaggingInfo(
                      pagecategoryData,
                      question.Step.QuestionText,
                      answer.Option.OptionText
                    );
                  "
                  >{{ answer.Option.OptionText }}</span
                >
                <span
                  v-if="question.Step.Option2 === answer.Option.OptionName"
                  :key="answer.Option.OptionName"
                  class="no ripple-out"
                  @click="
                    result(answer.Option, question.Step.StepName);
                    getTaggingInfo(
                      pagecategoryData,
                      question.Step.QuestionText,
                      answer.Option.OptionText
                    );
                  "
                  >{{ answer.Option.OptionText }}</span
                >
                <span
                  v-if="question.Step.Option3 === answer.Option.OptionName"
                  :key="answer.Option.OptionName"
                  class="no ripple-out"
                  @click="
                    result(answer.Option, question.Step.StepName);
                    getTaggingInfo(
                      pagecategoryData,
                      question.Step.QuestionText,
                      answer.Option.OptionText
                    );
                  "
                  >{{ answer.Option.OptionText }}</span
                >
                <span
                  v-if="question.Step.Option4 === answer.Option.OptionName"
                  :key="answer.Option.OptionName"
                  class="no ripple-out"
                  @click="
                    result(answer.Option, question.Step.StepName);
                    getTaggingInfo(
                      pagecategoryData,
                      question.Step.QuestionText,
                      answer.Option.OptionText
                    );
                  "
                  >{{ answer.Option.OptionText }}</span
                >
                <span
                  v-if="question.Step.Option5 === answer.Option.OptionName"
                  :key="answer.Option.OptionName"
                  class="no ripple-out"
                  @click="
                    result(answer.Option, question.Step.StepName);
                    getTaggingInfo(
                      pagecategoryData,
                      question.Step.QuestionText,
                      answer.Option.OptionText
                    );
                  "
                  >{{ answer.Option.OptionText }}</span
                >
              </template>
            </div>
            <span v-if="index !== 0" class="back-btn" @click="previous(question.Step.StepName)">
              <img :src="previousiconData" alt="previous" />
            </span>
          </li>
        </template>
      </ul>
      <span class="border-box"></span>
      <span class="border-box"></span>
    </div>
    <div v-if="isResultScreen" class="result-page-container">
      <div class="result-page-section">
        <div class="result-page-content">
          <Carousel :per-page="1" :mouse-drag="handleResize()">
            <template v-for="resultItem in results.productList">
              <Slide
                v-if="userSelectedResult.split('|').includes(resultItem.ProductItemId) === true"
                :id="resultItem.ProductItemId"
                :key="resultItem.ProductItemId"
                class="result-page-item-wrapper"
              >
                <div class="result-page-item">
                  <img :src="resultItem.ProductPackshotImageUrl" alt="" />
                </div>
                <div class="result-page-item">
                  <span>{{ resultItem.BrandLabel }}</span>
                  <h2>{{ resultItem.ProductName }}</h2>
                  <p>{{ resultItem.ProductShortDescription }}</p>
                  <div class="buy-wrapper">
                    <a :href="resultItem.ProductItemUrl" class="detail-btn">{{
                      detaillabelData
                    }}</a>
                    <a
                      v-if="
                        (resultItem.RetailerUrl == null || resultItem.RetailerUrl == '') &&
                        resultItem.hasShops == true
                      "
                      :shopdata="resultItem.SitecoreEretailersList.eretailershops"
                      class="buy-online"
                      @click="
                        commerceShops(
                          resultItem.SitecoreEretailersList.eretailershops,
                          true,
                          resultItem.ProductName,
                          resultItem.SitecoreEretailersList.descriptionText
                        );
                        getTaggingInfo(
                          pagecategoryData,
                          resultItem.BuyOnlineTaggingInfo.eventAction,
                          resultItem.BuyOnlineTaggingInfo.eventLabel
                        );
                      "
                      >{{ buyonlinelabelData }}</a
                    >
                    <a
                      v-else-if="resultItem.RetailerUrl != ''"
                      :href="resultItem.RetailerUrl"
                      class="buy-online"
                      target="_blank"
                      @click="
                        getTaggingInfo(
                          pagecategoryData,
                          resultItem.BuyOnlineTaggingInfo.eventAction,
                          resultItem.BuyOnlineTaggingInfo.eventLabel
                        )
                      "
                      >{{ buyonlinelabelData }}</a
                    >
                  </div>
                </div>
              </Slide>
            </template>
          </Carousel>
        </div>
        <button class="diagnose-btn" @click="showQuiz()">{{ diagnoseagainData }}</button>
      </div>
      <span class="border-box"></span>
      <span class="border-box"></span>
    </div>
    <div class="commerceConnector" :class="{ '-expanded': expandPanel }" :aria-hidden="ariaHidden">
      <div
        v-if="expandPanel"
        class="commerceConnector__overlay"
        @click="commerceShops('', false)"
      ></div>
      <div
        class="commerceConnector__layout"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-heading"
      >
        <button
          class="commerceConnector__close commerceConnector__tabIndex"
          tabindex="-1"
          @click="commerceShops('', false)"
          @keyup.esc="commerceShops('', false)"
        >
          <svg class="icon" role="img" aria-labelledby="closeCommerceConnector">
            <title id="closeCommerceConnector">Close window</title>
            <svg id="close" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M13.3 10.5l6.6 6.6c.8.8.8 2 0 2.8-.8.8-2 .8-2.8 0l-6.6-6.6-6.6 6.6c-.8.8-2 .8-2.8 0-.8-.8-.8-2 0-2.8l6.6-6.6-6.6-6.6c-.8-.8-.8-2 0-2.8s2-.8 2.8 0l6.6 6.6 6.6-6.6c.8-.8 2-.8 2.8 0 .8.8.8 2 0 2.8l-6.6 6.6z"
              ></path>
            </svg>
          </svg>
        </button>
        <form>
          <div class="commerceConnector__wrapper">
            <fieldset>
              <legend class="commerceConnector__description">
                <h1 id="modal-heading">
                  <strong>{{ descriptionProduct }}</strong>
                  {{ descriptionText }}
                </h1>
              </legend>
              <template>
                <ul class="commerceConnector__shops">
                  <li
                    v-for="shop in eretailershops"
                    :key="shop.title"
                    class="commerceConnector__item"
                  >
                    <a
                      :href="shop.link"
                      class="commerceConnector__radioLabel commerceConnector__tabIndex"
                      target="_blank"
                      @click="
                        getRetailerUrl(
                          shop.link,
                          shop.buyButton,
                          shop.taggingInfo.eventAction,
                          shop.taggingInfo.eventLabel
                        )
                      "
                    >
                      <img class="commerceConnector__logo" :src="shop.Image" alt="" />
                      {{ shop.title }}
                    </a>
                  </li>
                </ul>
              </template>
            </fieldset>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { AnalyticsHandler } from '../../../../../../Foundation/Core/code/Scripts/analyticsHandler/AnalyticsHandler';

import { Carousel, Slide } from 'vue-carousel';
export default {
  name: 'HairoilRecommender',
  components: {
    Carousel,
    Slide,
  },
  props: {
    questionData: { type: Object, required: true },
    answerData: { type: Object, required: true },
    resultsData: { type: Object, required: true },
    sectionimageData: { type: String, required: false },
    subtitleData: { type: String, required: false },
    headerimageData: { type: String, required: false },
    previousiconData: { type: String, required: false },
    ctalabelData: { type: String, required: false },
    prodoductimagesData: { type: Array, required: false },
    buyonlinelabelData: { type: String, required: false },
    detaillabelData: { type: String, required: false },
    diagnoseagainData: { type: String, required: false },
    themeimageData: { type: String, required: false },
    pagecategoryData: { type: String, required: false },
    dataDisplayimagechoices: { type: String, required: true },
  },
  data() {
    return {
      questions: this.questionData,
      answers: this.answerData,
      results: this.resultsData,
      productimages: this.prodoductimagesData,
      questionCount: 0,
      questionId: 'Step 1',
      //questionId: question.Step.StepName,
      eretailershops: [],
      descriptionProduct: '',
      descriptionText: '',
      isHomeScreen: true,
      isQuizScreen: false,
      isResultScreen: false,
      expandPanel: false,
      ariaHidden: true,
      productName: '',
      taggingUrl: '',
      userSelectedResult: '',
      eventAction: '',
      eventLabel: '',
    };
  },
  methods: {
    result(answer) {
      this.userSelectedResult = answer.ProductList;

      if (answer.IsItLastOption === false) {
        this.questionId = answer.NextStep;
        this.questionCount++;
      } else {
        this.isHomeScreen = false;
        this.isQuizScreen = false;
        this.isResultScreen = true;
      }
    },
    previous(stepName) {
      //console.log("stepName", stepName);
      //console.log("answer",this.answers.optionList);
      let tempArray = this.questions.stepList;
      let tempQuestionId;
      this.answers.optionList.forEach(function (answer) {
        //console.log("answer", answer);
        //console.log("answer", answer.Option.NextStep);
        if (stepName == answer.Option.NextStep) {
          tempArray.forEach(function (question) {
            if (
              answer.Option.OptionName == question.Step.Option1 ||
              answer.Option.OptionName == question.Step.Option2
            ) {
              tempQuestionId = question.Step.StepName;
            }
          });
        }
      });
      this.questionId = tempQuestionId;

      if (this.questionCount > 0) {
        this.questionCount--;
      }
    },
    showQuiz() {
      this.isHomeScreen = false;
      this.isQuizScreen = true;
      this.isResultScreen = false;
      this.questionId = 'Step 1';
      this.questionCount = 0;
    },

    isDisplayProduct(ProductItemId) {
      let newArr = this.userSelectedResult.split('|');
      newArr.filter(function (elem) {
        if (elem.trim() == ProductItemId) return true;
      });
    },
    handleResize() {
      return window.innerWidth <= 768;
    },
    commerceShops: function (
      eretailershops,
      isConnectorOpened,
      descriptionProduct,
      descriptionText
    ) {
      this.eretailershops = eretailershops;
      this.descriptionProduct = descriptionProduct;
      this.descriptionText = descriptionText;
      if (isConnectorOpened) {
        this.ariaHidden = false;
        //this.focusCloseButton();
        document.querySelector('body').classList.add('noScroll', '-fixed');
      } else {
        this.ariaHidden = true;
        document.querySelector('body').classList.remove('noScroll', '-fixed');
      }
      this.expandPanel = isConnectorOpened;
    },
    getRetailerUrl(url, buyButton, taggingA, taggingL) {
      this.taggingUrl = url;
      this.productName = buyButton;
      this.eventAction = taggingA;
      this.eventLabel = taggingL;
    },
    getTaggingInfo(pagecategory, action, label) {
      AnalyticsHandler.getAnalyticsHandler().push({
        type: 'userActionEvent',
        ecommerce: 'undefined',
        category: pagecategory,
        action: action,
        label: label,
      });
    },
  },
};
</script>
